import {QueryClient, UseInfiniteQueryResult} from '@tanstack/react-query'
import {broadcastQueryClient} from '@tanstack/query-broadcast-client-experimental'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            networkMode: 'online',
            retry: 1,
            retryOnMount: true,
            retryDelay: 1000,
            staleTime: 600000, //10 min
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true
        }
    }
})

broadcastQueryClient({queryClient, broadcastChannel: 'navigate'})

export const QUERY_KEYS = {
    ACTIVE_ASSIGNMENTS_RANGE: 'active-assignments-range',
    ACTIVE_ASSIGNMENTS_TABLE: 'active-assignments-range',
    ASSIGNMENT: 'assignment',
    ASSIGNMENTS_COMPLETED: 'assignments-completed',
    ASSIGNMENTS_COUNT: 'assignments-count',
    ASSIGNMENTS_REQUESTS: 'assignments-requests',
    CURRENT_ASSIGNMENTS: 'current-assignments',
    DECLINE_REASONS: 'decline-reasons',
    FREELANCER_PAYMENTS_DATES: 'freelancer-payments-dates',
    GEO_SELECT: 'geo-select',
    ME: 'me',
    REGIONS: 'regions',
    SPACES: 'spaces',
    UNRESPONSIVE_HOST_REASONS: 'unresponsive-host-reasons',
    INSIGHTS_METRICS: 'insights-metrics',
    COMMON_ISSUES: 'common-issues',
    LAST_FREELANCER_PAYMENTS: 'last-freelancer-payments',
    ASSIGNMENTS: 'assignments',
    REQUIRED_ACTIONS: 'required-actions',
    HOME_TABLE: 'home-table',
    GOOGLE_AUTH: 'google-oauth-callback',
    CONFIRM_EMAIL: 'confirm-email',
    CANCEL_REASON: 'cancel-reasons',
    PHOTOGRAPHERS_ME: 'photographers-me',
    FLOOR_PLAN_DEVICES: 'floor-plan-devices',
    ADMIN_ME: 'admin-me',
    OFFERINGS: 'offerings',
    CHATBOT_SESSION: 'chatbot-session'
} as const

export const infiniteQueryFetchNextPage = async (infiniteQuery: UseInfiniteQueryResult) => {
    if (infiniteQuery.hasNextPage && !infiniteQuery.isFetching) {
        await infiniteQuery.fetchNextPage()
    }
}
